import * as React from 'react';

const ArrowRightLong = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 658 322" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1302_118)">
      <path d="M648.6 183.6C661.1 171.1 661.1 150.8 648.6 138.3L520.6 10.2998C508.1 -2.2002 487.8 -2.2002 475.3 10.2998C462.8 22.7998 462.8 43.0998 475.3 55.5998L548.7 129H32C14.3 129 0 143.3 0 161C0 178.7 14.3 193 32 193H548.7L475.3 266.4C462.8 278.9 462.8 299.2 475.3 311.7C487.8 324.2 508.1 324.2 520.6 311.7L648.6 183.7V183.6Z" />
    </g>
    <defs>
      <clipPath id="clip0_1302_118">
        <rect width="658" height="322" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ArrowRightLong;
